import { css } from 'styled-components';
import { ThemedFunctor } from '@doveit/bricks';
import { borderRadiusRem } from './constant';

export const base: ThemedFunctor = () => css`
  padding-top: ${borderRadiusRem}rem;
`;

export const item: ThemedFunctor = ({
  $zIndex,
}) => css`
  position: relative;
  margin-top: -${borderRadiusRem}rem;
  z-index: ${$zIndex};
`;
